import { debounce, RoutablePage, deviceChange, isBreakpointLargeSync, configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';

/**
 * Component used to indicate loyalty progress.
 */
var LoyaltyProgressComponent = /** @class */ (function (_super) {
    __extends(LoyaltyProgressComponent, _super);
    function LoyaltyProgressComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.percentageLoyalty = 0;
        _this.userLevel = 0;
        _this.isComplete = false;
        _this.isLarge = false;
        _this.showRewardsButton = false;
        /**
         * As magic warned, there are cases in which multiple messages are sent
         * almost at the same time. We debounce them, just in case
         */
        _this.debouncedLoyaltyPointsUpdate = debounce(_this.handleLoyaltyPointsUpdate, 300);
        return _this;
    }
    LoyaltyProgressComponent.prototype.goToRewards = function () {
        this.isComplete = false;
        this.routeTo({
            route: RoutablePage.REWARDS,
        });
    };
    LoyaltyProgressComponent.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.deviceSubscription = deviceChange(function () {
                            _this.isLarge = isBreakpointLargeSync();
                        });
                        _b = this;
                        return [4 /*yield*/, configQuery("showProgressBarRewardButton")];
                    case 1:
                        _b.showRewardsButton =
                            (_a = (_c.sent())) !== null && _a !== void 0 ? _a : false;
                        this.fetchProgress();
                        this.unsubLoyalty = magic.events.loyaltyPointsUpdate(function (data) {
                            return _this.debouncedLoyaltyPointsUpdate(data);
                        }).unsub;
                        return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyProgressComponent.prototype.handleLoyaltyPointsUpdate = function (data) {
        if (this.userLevel < data.level) {
            this.isComplete = true;
            this.userLevel = data.level;
        }
        else {
            this.isComplete = false;
        }
        this.percentageLoyalty = data.progress;
    };
    LoyaltyProgressComponent.prototype.destroyed = function () {
        var _a;
        if (this.unsubLoyalty) {
            this.unsubLoyalty();
        }
        (_a = this.deviceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    LoyaltyProgressComponent.prototype.fetchProgress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, userId, loyaltyPromise, _a, progress, level;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        user = magic.session.getUser();
                        if (!user) {
                            return [2 /*return*/];
                        }
                        userId = user.userId;
                        loyaltyPromise = magic.invokeCached(60, magic.methods.loyalty, 'userProgress')({
                            userId: userId,
                        });
                        return [4 /*yield*/, loyaltyPromise];
                    case 1:
                        _a = _b.sent(), progress = _a.progress, level = _a.level;
                        this.percentageLoyalty = progress;
                        this.userLevel = level;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LoyaltyProgressComponent.prototype, "roundedProgress", {
        /**
         * progress gets floored instead of rounded otherwise with a 99,51% progress the user
         * would see 100% triggering the UI effect for level completed.
         */
        get: function () {
            return this.isComplete ? 100 : Math.floor(this.percentageLoyalty);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoyaltyProgressComponent.prototype, "levelTranslation", {
        get: function () {
            return this.isComplete
                ? 'progress-bar.levelUp-text'
                : 'progress-bar.level-text';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Emitted when the info icon is clicked.
     */
    LoyaltyProgressComponent.prototype.userLevelUpdated = function () {
        return this.userLevel;
    };
    /**
     * Emitted when the info icon is clicked.
     */
    LoyaltyProgressComponent.prototype.infoClick = function () {
        return;
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "topNavVariant", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "shouldShowInfo", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "showProgressBarOnly", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "showLevelOnTop", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "displayRewardsButton", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyProgressComponent.prototype, "wrapperWidth", void 0);
    __decorate([
        Emit('toggle-menu'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LoyaltyProgressComponent.prototype, "goToRewards", null);
    __decorate([
        Watch('userLevel'),
        Emit('userLevelUpdated'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LoyaltyProgressComponent.prototype, "userLevelUpdated", null);
    __decorate([
        Emit('info'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LoyaltyProgressComponent.prototype, "infoClick", null);
    LoyaltyProgressComponent = __decorate([
        Component({
            name: 'loyalty-progress',
        })
    ], LoyaltyProgressComponent);
    return LoyaltyProgressComponent;
}(Mixins(MagicConfigMixin)));

export default LoyaltyProgressComponent;
